module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-juliane.90e958e9.jpeg";